// 統一匯出所有線路圖配置和渲染函數

import { directStartConfig, renderDirectStart } from './DirectStart';

// 線路圖配置陣列
export const diagramConfigs = [
    {
        ...directStartConfig,
        isInteractive: true, // 互動式電路圖
    },
    {
        id: 1,
        name: '直接啟動+3r',
        description: '使用圖片顯示',
        image: '/picture/直接啟動+3r.jpg',
        isInteractive: false, // 圖片模式
    },
    {
        id: 2,
        name: '直接啟動+3hr+自設時間(水利會版本)',
        description: '使用圖片顯示',
        image: '/picture/直接啟動+3hr+自設時間(水利會版本).jpg',
        isInteractive: false,
    },
    {
        id: 3,
        name: 'Y-△',
        description: '使用圖片顯示',
        image: '/picture/Y-△.jpg',
        isInteractive: false,
    },
    {
        id: 4,
        name: 'Y-△+3hr+自設時間（水利會版本3)',
        description: '使用圖片顯示',
        image: '/picture/Y-△+3hr+自設時間（水利會版本3).jpg',
        isInteractive: false,
    },
];

// 渲染函數對應表
export const renderFunctions = {
    0: renderDirectStart,      // 直接啟動
};

// 根據索引獲取渲染函數
export const getDiagramRenderer = (index) => {
    return renderFunctions[index] || null;
};
